import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from 'axios';

const useInputActive = () => {
    const [isFocused, setIsFocused] = useState(false);
    const [hasValue, setHasValue] = useState(false);

    const onFocus = () => setIsFocused(true);
    const onBlur = (e) => {
        setIsFocused(false);
        setHasValue(!!e.target.value.trim());
    };

    const isActive = isFocused || hasValue;

    return { isActive, onFocus, onBlur };
};

export default function Form() {
    const formRef = useRef();

    useEffect(() => {
        const scrollToSelf = () => {
            if (formRef.current) {
                const offset = formRef.current.getBoundingClientRect().top + window.pageYOffset - 150;

                window.scrollTo({
                    top: offset,
                    behavior: 'smooth',
                });
            }
        };

        window.addEventListener("scrollToForm", scrollToSelf);
        return () => window.removeEventListener("scrollToForm", scrollToSelf);
    }, []);

    const nameInput = useInputActive();
    const emailInput = useInputActive();
    const phoneInput = useInputActive();
    const descInput = useInputActive();

    const navigate = useNavigate();
    const { register, formState: { errors }, setError, setFocus, clearErrors } = useForm();

    const [form, setForm] = useState({
        name: '',
        mobileno: '',
        emailId: '',
        description: ''
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        clearErrors();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.name.trim()) {
            setError("name", { type: "required" });
            setFocus("name");
        } else if (!form.emailId.trim()) {
            setError("emailId", { type: "required", });
            setFocus("emailId");
        } else if (!/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(form.emailId)) {
            setError("emailId", { type: "pattern", });
            setFocus("emailId");
        } else if (!form.mobileno.trim()) {
            setError("mobileno", { type: "required", });
            setFocus("mobileno");
        } else if (form.mobileno.length < 10) {
            setError("mobileno", { type: "minLength", });
            setFocus("mobileno");
        } else if (form.mobileno.length > 10) {
            setError("mobileno", { type: "maxLength", });
            setFocus("mobileno");
        } else if (!form.description.trim()) {
            setError("description", { type: "required", });
            setFocus("description");
        } else {
            try {
                document.getElementById("frmbtn").style.display = "none";
                document.getElementById("load").style.display = "block";
                //const response = await axios.post('https://zyxmedia.in/demo/api.php', form);
                //alert("Submitted Successfully: " + response.data);
                await axios.post('https://zyxmedia.in/demo/api.php', form);
                setTimeout(() => {
                    navigate("/Form-Confirm");
                }, 2000);
            } catch (error) {
                console.error("Error submitting form", error);
                alert("Submission failed.");
            }
        }
    };
    return (
        <div className='form-group mxw-400 m-auto mt-4' ref={formRef}>
            <form onSubmit={handleSubmit}>
                <ul className='float-none'>
                    <li className={nameInput.isActive ? 'input-active' : ''}>
                        <label className='label-txt'>Name</label>
                        <input type='text' id='name' name="name" {...register("name")} onChange={handleChange} className="input-txt" onFocus={nameInput.onFocus} onBlur={nameInput.onBlur} />
                        {errors.name && errors.name.type === "required" && (<div className="error-txt">Please enter your Name</div>)}
                    </li>
                    <li className={emailInput.isActive ? 'input-active' : ''}>
                        <label className='label-txt'>Email ID</label>
                        <input type="text" id="emailId" name="emailId" {...register("emailId")} inputMode="email" onChange={handleChange} className="input-txt" onFocus={emailInput.onFocus} onBlur={emailInput.onBlur} />
                        {errors.emailId && errors.emailId.type === "required" && (<div className="error-txt">Please enter your Email ID</div>)}
                        {errors.emailId && errors.emailId.type === "pattern" && (<div className="error-txt">Please check the Email ID</div>)}
                    </li>
                    <li className={phoneInput.isActive ? 'input-active' : ''}>
                        <label className='label-txt'>Phone No.</label>
                        <label className="mobile-code">+91</label>
                        <input type="text" id="mobileno" name="mobileno" {...register("mobileno")} inputMode="tel" maxLength="10" onChange={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ''); handleChange(e); }} className="input-txt mobile-txt" onFocus={phoneInput.onFocus} onBlur={phoneInput.onBlur} />
                        {errors.mobileno && errors.mobileno.type === "required" && (<div className="error-txt">Please enter your Phone No.</div>)}
                        {errors.mobileno && errors.mobileno.type === "minLength" && (<div className="error-txt">Phone No.!, required at least 10 digits</div>)}
                        {errors.mobileno && errors.mobileno.type === "maxLength" && (<div className="error-txt">Please check your Phone No.!, 10 digits only</div>)}
                    </li>
                    <li className={descInput.isActive ? 'input-active' : ''}>
                        <label className='label-txt'>Description</label>
                        <textarea id='description' name="description" {...register("description")} onChange={handleChange} className='area-txt' onFocus={descInput.onFocus} onBlur={descInput.onBlur}></textarea>
                        {errors.description && errors.description.type === "required" && (<div className="error-txt">Please enter your Description</div>)}
                    </li>
                    <li className='txt-rt mnh-auto mb-0'>
                        <div className='glow-btn d-in-blk'>
                            <input type="submit" id="frmbtn" value="Get a Call" className="submit-btn" />
                            <div className="submit-spin txt-center" id="load" style={{ display: "none" }}></div>
                        </div>
                    </li>
                </ul>
            </form>
        </div>
    )
}
